import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  empty: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '48px 0px'
  }
}))
